<template>
  <div :style="{opacity: loaded ? 1 : 0}"
       class="code-with-blanks">
    <p class="help">完成下面 <b>{{ blanks - 1 || 1 }}</b> 处填空</p>
    <div class="code-template"
         @click="onClick">
      <pre class="language-python line-numbers"><code v-html="content"></code></pre>
    </div>

    <div :style="style"
         class="card blank-editor">
      <ace-editor
          v-model="editorStyle.code"
          :ref="'code-blanks-editor-' + _uid"
          :auto-height="false"
          :height="'200px'"
          :lang="'python'"></ace-editor>

      <div class="card-content condense">
        <div class="buttons">
          <button class="button is-primary is-small"
                  @click="editorConfirm">确认
          </button>
          <button class="button is-light is-small"
                  @click="editorStyle.active = false">取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'prismjs'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-cpp'
import 'prismjs/plugins/keep-markup/prism-keep-markup.min'
import 'prismjs/plugins/line-numbers/prism-line-numbers.min'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'
import AceEditor from '@/common/ace_editor/AceEditor'
import _ from 'lodash'

export default {
  components: { AceEditor },
  props: { 'language': {}, 'template': {}, 'value': {}, 'readonly': { default: false } },
  data () {
    return {
      prismLang: {
        'Python': 'python',
        'python': 'python',
        'c++': 'cpp',
        'c': 'c'
      },
      content: '',
      blanks: 0,
      loaded: false,
      codes: [],
      changeInside: false,
      editorStyle: {
        active: false,
        activeIndex: 0,
        code: '',
        x: 0,
        y: 0
      }
    }
  },
  watch: {
    value () {
      if (!this.changeInside) {
        this.initCode()
        this.changeInside = false
      }
    }
  },
  computed: {
    style () {
      return {
        transform: `translate(${this.editorStyle.x}px,${this.editorStyle.y}px)`,
        width: this.editorStyle.w + 'px',
        opacity: this.editorStyle.active ? 1 : 0,
        pointerEvents: this.editorStyle.active ? 'initial' : 'none',
        zIndex: this.editorStyle.active ? 1 : -1
      }
    }
  },
  mounted () {
    this.initCode()
  },
  methods: {
    initCode () {
      this.blanks = this.template.split('#####').length
      this.codes = new Array(this.blanks).fill('')

      if (this.value) {
        if (this.blanks <= 2) {
          this.codes[0] = this.value
        } else {
          try {
            this.codes = JSON.parse(this.value)
            if (this.codes.length !== this.blanks) {
              this.codes.length = this.blanks
              this.changeInside = true

              if (this.blanks <= 2) {
                this.$emit('input', this.codes[0] || '')
              } else {
                this.$emit('input', JSON.stringify(this.codes))
              }
            }
          } catch (e) {
            // pass
          }
        }
      }
      this.reloadContent()
    },
    reloadContent () {
      this.content = this.template.replace(/\r\n/g, '\n')
      this.content = _.escape(this.content)

      if (this.blanks === 1) {
        // 没有空白，默认加在最后
        this.content = this.content +
                       `<span class="code-blanks multiline-code-blanks" data-id="0">${_.escape(this.codes[0]) || '<b class="is-text-link">在此输入一行或多行代码</b>'}</span>`
      } else {
        this.content = this.content.split('#####').reduce((ret, code, index) => {
          if (index === 0) {
            return code
          } else {
            if (ret[ret.length - 1] === '\n' && (code[0] === '\n' || code[0] === void 0)) {
              return ret + `<span class="code-blanks multiline-code-blanks" data-id="${index - 1}">${_.escape(this.codes[index - 1]) || '<b class="is-text-link">点击在此输入一行或多行代码</b>'}</span>` + code
            } else {
              return ret + `<span class="code-blanks inline-code-blanks" data-id="${index - 1}">${_.escape(this.codes[index - 1]) || '<b class="is-text-link">点击在此输入代码</b>'}</span>` + code
            }
          }
        }, '')
      }

      this.loaded = true
      setTimeout(() => {
        Prism.highlightAllUnder(this.$el, false, () => {
          this.loaded = true
        })
      }, 0)
    },
    onClick ($event) {
      if (this.readonly) return
      let target = $event.target
      while ($event) {
        if (!target.classList) break
        if (target.classList.contains('code-blanks') || target.classList.contains('code-with-blanks')) {
          break
        } else {
          target = target.parentNode
        }
      }
      if (target.classList && target.classList.contains('code-blanks')) {
        if (this.$el.offsetWidth > 500) {
          this.editorStyle.x = target.offsetLeft + 52
          this.editorStyle.w = this.$el.offsetWidth - target.offsetLeft - 103 + 38
        } else {
          this.editorStyle.x = 52
          this.editorStyle.w = this.$el.offsetWidth - 103 + 38
        }
        this.editorStyle.y = target.offsetTop + target.offsetHeight + 38
        this.editorStyle.active = true
        this.editorStyle.activeIndex = parseInt(target.dataset.id)
        this.editorStyle.code = this.codes[this.editorStyle.activeIndex] || ''
        const editor = this.$refs['code-blanks-editor-' + this._uid]
        if (editor && editor.editor) {
          editor.editor.focus()
        }
      } else {
        if (this.editorStyle.active && this.editorStyle.code !== this.codes[this.editorStyle.activeIndex]) {
          this.editorConfirm()
        }
        this.editorStyle.active = false
      }
    },
    editorConfirm () {
      this.$set(this.codes, this.editorStyle.activeIndex, this.editorStyle.code)
      this.editorStyle.active = false
      this.reloadContent()
      this.changeInside = true
      if (this.blanks <= 2) {
        this.$emit('input', this.codes[0] || '')
      } else {
        this.$emit('input', JSON.stringify(this.codes))
      }
    },
    isFullfill () {
      return (this.blanks - 1) <= this.codes.filter(c => c).length
    }
  }
}
</script>
<style lang="stylus" scoped>
.line-numbers {
  background white !important
  overflow visible !important
  padding-left 3.8em !important
}

.help {
  margin-left 1rem
}

.code-template {
  padding-bottom 250px
}

.code-with-blanks {
  position relative
  max-height calc(100vh - 17rem)
  overflow auto
}

.blank-editor {
  position absolute
  left 0
  top 0
  width 100%
  z-index 1
  border 1px solid $link
  transition opacity .3s
  border-radius 0
  overflow auto
}
</style>
<style lang="stylus">
.code-blanks {
  cursor pointer
  box-shadow 0 0 0 1px rgb(50, 115, 220)

  &:hover {
    background $linkLight
  }
}

.inline-code-blanks {
}

.multiline-code-blanks {
  display: block;
}
</style>
